








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { saveToCliboard, formatPeso, formatPrice } from '@/utils';

@Component({})
export default class BonusPriceComponent extends Vue {
    @Prop() public bonus: boolean;
    @Prop() public value: number;
    @Prop() public peso: boolean;

    get priceStr() {
        if (this.peso) {
            return formatPeso(this.value);
        } else {
            return formatPrice(this.value);
        }
    }
}
